import React, { useState, useEffect } from "react";
import TopNavbar from "./TopNavbar";
import "./AccountSettings.css";
import { useNavigate } from "react-router-dom";
import toast from '../utils/toastManager';
import { QRCodeCanvas } from 'qrcode.react';
// 企业微信绑定功能已移除

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const IMAGES_BASE_URL = process.env.REACT_APP_images_API_BASE_URL;

export default function AccountSettings() {
  const [user, setUser] = useState(null);
  const [showQR, setShowQR] = useState(false);
  const [qrUrl, setQrUrl] = useState("");
  const [modalType, setModalType] = useState(""); // "password" | "nickname" | "avatar" | "crm"
  const [nicknameInput, setNicknameInput] = useState("");
  const [oldPwd, setOldPwd] = useState("");
  const [newPwd, setNewPwd] = useState("");
  const [avatarFile, setAvatarFile] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [qrType, setQrType] = useState('work');
  // CRM人员列表相关状态
  const [crmUsers, setCrmUsers] = useState([]);
  const [selectedCrmUser, setSelectedCrmUser] = useState(null);
  const [crmUsersLoading, setCrmUsersLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${API_BASE_URL}/auth/get_detail`, {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem("token") || ""}`
      }
    })
      .then(res => res.json())
      .then(data => {
        setUser(data);
        setNicknameInput(data.accountNickName || "");
        // 缓存头像和昵称
        if (data.avatar) localStorage.setItem("avatar", data.avatar);
        if (data.accountNickName) localStorage.setItem("accountNickName", data.accountNickName);
      });
  }, []);

  // 企业微信绑定方法（已移除）
  const handleBindWechatWork = () => {
    toast.error('企业微信绑定功能已移除');
  };

  // 解除微信绑定方法
  const handleUnbindWechat = async () => {
    if (!window.confirm('确定要解除微信绑定吗？')) {
      return;
    }
    
    try {
      const username = user?.userName;
      const response = await fetch(`${API_BASE_URL}/auth/removeWechat/${username}/1`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token') || ''}`
        }
      });

      const data = await response.json();
      
      if (data.success) {
        toast.success('微信绑定已解除！');
        // 刷新页面以更新状态
        window.location.reload();
      } else {
        toast.error(data.message || '解除绑定失败');
      }
    } catch (error) {
      console.error('解除微信绑定失败:', error);
      toast.error('解除绑定失败，请稍后重试');
    }
  };

  // 微信绑定方法
  const handleBindWechat = () => {
    // 检查是否在微信浏览器中
    const isWechat = /MicroMessenger/i.test(navigator.userAgent);
    
    // 直接使用userId作为state参数
    const userId = user?.userId || user?.userName || 'account';
    const appid = process.env.REACT_APP_WECHAT_APP_ID;
    const redirect_uri = encodeURIComponent(`${window.location.origin}/wechat-bind-callback`);
    const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=${userId}#wechat_redirect`;
    
    if (isWechat) {
      // 在微信浏览器中，直接跳转到授权页面
      window.location.href = url;
    } else {
      // 非微信浏览器，显示二维码
    setQrUrl(url);
    setShowQR(true);
    setQrType('wechat');
    }
  };

  // 打开CRM账号绑定弹窗
  const handleOpenCrmBind = async () => {
    setModalType("crm");
    setSelectedCrmUser(null);
    setCrmUsersLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/brand-library/crm-users`, {
        headers: {
          "Authorization": `Bearer ${localStorage.getItem("token") || ""}`
        }
      });
      const data = await res.json();
      if (data.success) {
        setCrmUsers(data.data || []);
        // 如果已有绑定，自动选中
        if (user?.crmAccountId) {
          const existing = (data.data || []).find(u => u.id === user.crmAccountId);
          if (existing) {
            setSelectedCrmUser(existing);
          }
        }
      } else {
        toast.error(data.message || '获取CRM人员列表失败');
      }
    } catch (error) {
      console.error('获取CRM人员列表失败:', error);
      toast.error('获取CRM人员列表失败');
    } finally {
      setCrmUsersLoading(false);
    }
  };

  // 保存CRM账号绑定
  const handleSaveCrmBind = async () => {
    if (!selectedCrmUser) {
      toast.error('请选择CRM账号');
      return;
    }
    try {
      const res = await fetch(`${API_BASE_URL}/auth/change_detail`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem("token") || ""}`
        },
        body: JSON.stringify({
          crmAccountId: selectedCrmUser.id
        })
      });
      const data = await res.json();
      if (data.success) {
        toast.success('CRM账号绑定成功！');
        setModalType("");
        // 更新用户数据
        setUser(prev => ({ ...prev, crmAccountId: selectedCrmUser.id }));
      } else {
        toast.error(data.msg || '绑定失败');
      }
    } catch (error) {
      console.error('保存CRM账号失败:', error);
      toast.error('保存失败，请稍后重试');
    }
  };

  // 解除CRM账号绑定
  const handleUnbindCrm = async () => {
    if (!window.confirm('确定要解除CRM账号绑定吗？')) {
      return;
    }
    try {
      const res = await fetch(`${API_BASE_URL}/auth/change_detail`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem("token") || ""}`
        },
        body: JSON.stringify({
          crmAccountId: ""
        })
      });
      const data = await res.json();
      if (data.success) {
        toast.success('CRM账号绑定已解除！');
        setUser(prev => ({ ...prev, crmAccountId: "" }));
      } else {
        toast.error(data.msg || '解除绑定失败');
      }
    } catch (error) {
      console.error('解除CRM绑定失败:', error);
      toast.error('解除绑定失败，请稍后重试');
    }
  };

  // 弹窗关闭
  const closeModal = () => {
    setModalType("");
    setOldPwd("");
    setNewPwd("");
    setNicknameInput(user.accountNickName || "");
    setAvatarFile(null);
  };

  // 修改昵称或头像提交
  const handleDetailSave = async () => {
    let avatarUrl = user.avatar;
    // 1. 如果有新头像，先上传
    if (avatarFile) {
      const formData = new FormData();
      formData.append("file", avatarFile);
      const res = await fetch(`${API_BASE_URL}/forms/upload`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${localStorage.getItem("token") || ""}`
        },
        body: formData
      });
      const data = await res.json();
      if (data.url) {
        // 拼接完整图片地址
        avatarUrl = data.url.startsWith('http')
          ? data.url
          : IMAGES_BASE_URL.replace(/\/$/, '') + '/' + data.url.replace(/^\//, '');
      } else {
        toast.error(data.msg || "头像上传失败");
        return;
      }
    }
    // 2. 保存昵称和头像路径
    const res2 = await fetch(`${API_BASE_URL}/auth/change_detail`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("token") || ""}`
      },
      body: JSON.stringify({
        accountNickName: nicknameInput,
        avatar: avatarUrl
      })
    });
    const data2 = await res2.json();
    if (data2.success) {
      toast.success("信息修改成功！");
      closeModal();
      window.location.reload();
    } else {
      toast.error(data2.msg || "修改失败");
    }
  };

  // 修改密码提交
  const handlePasswordSave = async () => {
    if (!oldPwd || !newPwd) {
      toast.error("请填写完整");
      return;
    }
    const res = await fetch(`${API_BASE_URL}/auth/change_password`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("token") || ""}`
      },
      body: JSON.stringify({ oldPassword: oldPwd, newPassword: newPwd })
    });
    const data = await res.json();
    if (data.success) {
      toast.success("密码修改成功！");
      closeModal();
    } else {
      toast.error(data.msg || "修改失败");
    }
  };

  // 二维码弹窗 - 使用QRCodeCanvas组件，不需要微信官方JS

  if (!user) {
    return (
      <>
        <TopNavbar />
        <div className="account-settings-layout">
          <div className="account-settings-content">加载中...</div>
        </div>
      </>
    );
  }

  return (
    <>
      <TopNavbar />
      <div className="account-settings-layout">
        {/* 左侧导航 */}
        <div className="account-sidebar">
          <div className="sidebar-user">
            {user.avatar
              ? <img className="sidebar-avatar" src={user.avatar} alt="头像" />
              : <div className="sidebar-avatar">{user.accountNickName?.[0] || "U"}</div>
            }
            <div className="sidebar-nickname">{user.accountNickName}</div>
          </div>
          <ul className="sidebar-menu">
            <li className="active">账号管理</li>
          </ul>
        </div>
        {/* 右侧内容 */}
        <div className="account-settings-content">
          {/* 账号信息 */}
          <div className="account-info-panel">
            <h3>登录账号</h3>
            <div className="info-row">
              <span>账号：</span>
              <span>{user.userName}</span>
              <button className="btn small" onClick={() => setModalType("password")}>修改密码</button>
            </div>
            <div className="info-row">
              <span>昵称：</span>
              <span>{user.accountNickName || "未设置"}</span>
              <button className="btn small" onClick={() => setModalType("nickname")}>修改</button>
            </div>
            <div className="info-row">
              <span>头像：</span>
              {user.avatar ? (
                <img src={user.avatar} alt="头像" style={{ width: 32, height: 32, borderRadius: "50%" }} />
              ) : (
                <span>未设置</span>
              )}
              <button className="btn small" onClick={() => setModalType("avatar")}>修改</button>
            </div>
          </div>
          {/* 第三方账号绑定 */}
          <div className="third-party-bind-panel">
            <h3>第三方账号绑定</h3>
            <table className="bind-table">
              <thead>
                <tr>
                  <th>序号</th>
                  <th>绑定账号信息</th>
                  <th>详情</th>
                  <th>状态</th>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody>
                {/* 企业微信绑定行 */}
                {user.workNickName ? (
                  <tr>
                    <td>1</td>
                    <td>企业微信</td>
                    <td>{user.workAvatar && <img className="bind-avatar" src={user.workAvatar} alt="" />}<span>{user.workNickName}</span></td>
                    <td>--</td>
                    <td><span className="status-dot active"></span>使用中</td>
                    <td><button className="btn outline small">解除绑定</button></td>
                  </tr>
                ) : (
                  <tr>
                    <td>1</td>
                    <td>企业微信</td>
                    <td>--</td>
                    <td><span style={{ color: '#faad14' }}>未绑定</span></td>
                    <td><button className="btn primary small" onClick={handleBindWechatWork}>绑定企业微信</button></td>
                  </tr>
                )}
                {/* 微信绑定行 */}
                {user.nickName ? (
                  <tr>
                    <td>2</td>
                    <td>微信</td>
                    <td><span>{user.nickName}</span></td>
                    <td><span className="status-dot active"></span>使用中</td>
                    <td><button className="btn outline small" onClick={handleUnbindWechat}>解除绑定</button></td>
                  </tr>
                ) : (
                  <tr>
                    <td>2</td>
                    <td>微信</td>
                    <td>--</td>
                    <td><span style={{ color: '#faad14' }}>未绑定</span></td>
                    <td><button className="btn primary small" onClick={handleBindWechat}>绑定微信</button></td>
                  </tr>
                )}
                {/* CRM账号绑定行 */}
                {user.crmAccountId ? (
                  <tr>
                    <td>3</td>
                    <td>CRM账号</td>
                    <td><span>{user.crmAccountName || user.crmAccountId}</span></td>
                    <td><span className="status-dot active"></span>使用中</td>
                    <td><button className="btn outline small" onClick={handleUnbindCrm}>解除绑定</button></td>
                  </tr>
                ) : (
                  <tr>
                    <td>3</td>
                    <td>CRM账号</td>
                    <td>--</td>
                    <td><span style={{ color: '#faad14' }}>未绑定</span></td>
                    <td><button className="btn primary small" onClick={handleOpenCrmBind}>关联CRM</button></td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {/* 弹窗区域 */}
      {modalType && (
        <div style={{
          position: 'fixed', left: 0, top: 0, width: '100vw', height: '100vh',
          background: 'rgba(0,0,0,0.25)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 32, minWidth: 320, boxShadow: '0 4px 24px rgba(0,0,0,0.12)' }}>
            {modalType === "nickname" && (
              <>
                <h4 style={{ marginBottom: 16 }}>修改昵称</h4>
                <input
                  className="nickname-input"
                  value={nicknameInput}
                  onChange={e => setNicknameInput(e.target.value)}
                  style={{ width: "100%", marginBottom: 16 }}
                />
                <div>
                  <button className="btn primary" onClick={handleDetailSave}>保存</button>
                  <button className="btn" style={{ marginLeft: 12 }} onClick={closeModal}>取消</button>
                </div>
              </>
            )}
            {modalType === "avatar" && (
              <>
                <h4 style={{ marginBottom: 16 }}>修改头像</h4>
                <input
                  type="file"
                  accept="image/*"
                  onChange={e => setAvatarFile(e.target.files[0])}
                  style={{ marginBottom: 16 }}
                />
                <div>
                  <button className="btn primary" onClick={handleDetailSave}>保存</button>
                  <button className="btn" style={{ marginLeft: 12 }} onClick={closeModal}>取消</button>
                </div>
              </>
            )}
            {modalType === "password" && (
              <>
                <h4 style={{ marginBottom: 16 }}>修改密码</h4>
                <input
                  type="password"
                  className="nickname-input"
                  placeholder="原密码"
                  value={oldPwd}
                  onChange={e => setOldPwd(e.target.value)}
                  style={{ width: "100%", marginBottom: 12 }}
                />
                <input
                  type="password"
                  className="nickname-input"
                  placeholder="新密码"
                  value={newPwd}
                  onChange={e => setNewPwd(e.target.value)}
                  style={{ width: "100%", marginBottom: 16 }}
                />
                <div>
                  <button className="btn primary" onClick={handlePasswordSave}>保存</button>
                  <button className="btn" style={{ marginLeft: 12 }} onClick={closeModal}>取消</button>
                </div>
              </>
            )}
            {modalType === "crm" && (
              <>
                <h4 style={{ marginBottom: 16 }}>选择CRM账号</h4>
                {crmUsersLoading ? (
                  <div style={{ textAlign: 'center', padding: '20px 0', color: '#999' }}>加载中...</div>
                ) : (
                  <div style={{ maxHeight: '300px', overflowY: 'auto', marginBottom: 16, border: '1px solid #eee', borderRadius: 8 }}>
                    {crmUsers.length === 0 ? (
                      <div style={{ textAlign: 'center', padding: '20px', color: '#999' }}>暂无数据</div>
                    ) : (
                      crmUsers.map((user, index) => (
                        <div
                          key={index}
                          onClick={() => setSelectedCrmUser(user)}
                          style={{
                            padding: '12px 16px',
                            cursor: 'pointer',
                            borderBottom: index < crmUsers.length - 1 ? '1px solid #f0f0f0' : 'none',
                            background: selectedCrmUser?.id === user.id ? '#e6f7ff' : '#fff',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 12
                          }}
                        >
                          <input
                            type="radio"
                            checked={selectedCrmUser?.id === user.id}
                            onChange={() => setSelectedCrmUser(user)}
                            style={{ width: 16, height: 16, cursor: 'pointer' }}
                          />
                          <span>{user.name}</span>
                        </div>
                      ))
                    )}
                  </div>
                )}
                <div>
                  <button className="btn primary" onClick={handleSaveCrmBind}>保存</button>
                  <button className="btn" style={{ marginLeft: 12 }} onClick={closeModal}>取消</button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
      {showQR && (
        <div style={{ position: 'fixed', left: 0, top: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.25)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 32, boxShadow: '0 4px 24px rgba(0,0,0,0.12)', textAlign: 'center', maxWidth: '90vw' }}>
            <h4 style={{ marginBottom: 16 }}>请用微信扫码绑定</h4>
            <div style={{ marginBottom: 16, fontSize: '14px', color: '#666' }}>
              扫描二维码后，请在微信中完成授权
            </div>
            <QRCodeCanvas value={qrUrl} size={200} includeMargin={true} />
            <div style={{ marginTop: 16, fontSize: '12px', color: '#999' }}>
              绑定成功后会自动跳转回账号管理页面
            </div>
            <div style={{ marginTop: 20 }}>
              <button className="btn" onClick={() => setShowQR(false)}>关闭</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
} 